import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';

import { Header } from '@d19n/ui-header';
import Footer from './Sections/Footer';
import { Link, navigate } from "gatsby";
import 'bootstrap/dist/css/bootstrap.min.css';
import './../assets/fonts/fonts.css';
import './../assets/styles/app.scss';
import Logo from './../assets/image/svg/business-logo.svg';

import { variables } from "@d19n/ui-core";
import { Helmet } from "react-helmet";
import TwilioChat3 from './TwilioChat3';

const SiteWrapper = styled.div`
  font-family: ${variables.fontFamilyPrimary};
  font-size: 16px;
  padding-top: 73px;
  opacity: 0;
  &.page-loaded {
    opacity: 1;
  }
`;

const Loader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 9999999999;
  opacity: 1;
  visibility: visible;
  transition: all 1s ease-out 0.5s;

  &.inActive {
    opacity: 0;
    visibility: hidden;
  }
`;

export const menuItems = [
  {
    name: null,
    isExternal: false,
    label: "Business size",
    withDropdown: true,
    items: [
      {
        name: null,
        isExternal: false,
        label: null,
        items: [
          {
            name: `small-business`,
            isExternal: false,
            label: "Small Business",
            items: null
          },
          {
            name: `medium-business`,
            isExternal: false,
            label: "Medium Business",
            items: null
          }
        ]
      }
    ]
  },
  {
    name: null,
    isExternal: false,
    label: "Products",
    withDropdown: true,
    items: [
      {
        name: null,
        isExternal: false,
        label: null,
        items: [
          {
            name: `internet-packages`,
            isExternal: false,
            label: "Broadband",
            items: null
          },
          {
            name: `youphone`,
            isExternal: false,
            label: "Phone",
            items: null
          },
          {
            name: `extras`,
            isExternal: false,
            label: "Extras",
            items: null
          },
          {
            name: `products-business`,
            isExternal: false,
            label: "Benefits",
            items: null
          }
        ]
      }
    ]
  },
  {
    name: `request-callback`,
    isExternal: false,
    label: "Contact",
    items: null
  }
];

const Layout = ({ children }) => {

    const [visibleLoader, setVisibleLoader] = useState(true);

    useLayoutEffect(() => {
        setVisibleLoader(false);
    }, []);
   
    return (
        <>
            <Helmet>
                <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1, shrink-to-fit=no, maximum-scale=1.0, user-scalable=0"
                />

                {/* Favicon main */}
                <link rel="icon" href="/favicon.ico" sizes="any"/>
                <link rel="icon" href="/favicon.svg" type="image/svg+xml"/>

                {/* Apple (iOS/iPadOS) */}
                <link rel="apple-touch-icon" sizes="167x167" href="/favicon-167x167.png"/>
                <link rel="apple-touch-icon" sizes="180x180" href="/favicon-180x180.png"/>

                {/* PNG fallbacks */}
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>

                {/* PWA / Android */}
                <link rel="icon" type="image/png" sizes="192x192" href="/favicon-192x192.png"/>
                <link rel="icon" type="image/png" sizes="512x512" href="/favicon-512x512.png"/>

                <link
                    rel="stylesheet"
                    type="text/css"
                    charset="UTF-8"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
                <script
                  type="text/javascript"
                  src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
                  async
                ></script>
            </Helmet>
            <Loader id="loading" className={visibleLoader ? '' : 'inActive'} />
            <SiteWrapper className={visibleLoader ? '' : 'page-loaded'}>
                <Header
                  LinkComponent={Link}
                  navigate={navigate}
                  websiteType="business"
                  logo={Logo}
                  menuItems={menuItems}
                />
                <div className="page-wrapper">
                    {children}
                </div>
                <Footer />
                <TwilioChat3 />
            </SiteWrapper>
        </>
    );
}

export default Layout;